export default "__VITE_ASSET__026a77c7__"